import React from 'react';
import MainPage from './MainPage';

const Ceremony = () => {
  return <MainPage tag='CEREMONY' title='CEREMONY' url='/ceremony'/>;
}

export default Ceremony;